import axios from "../axios";
import * as createResponseHandling from "./../responseHandling/fetch"


async function signUp(props) {
  const body = {
    user: {
      email: props.email,
      password: props.password,
      password_confirmation: props.confirmPassword,
      username: props.username,
      user_personal_info_attributes: {
        occupation: props.occupation
      },
      library_id: props.library,
    }
  };
  const res = await axios.post(`/users`, body);
  return createResponseHandling.parseResponse(res);
}

async function resendConfirmationEmail(props) {
  const body = {
    user: {
      email: props.email,
    },
  }

  const res = await axios.post(`/users/confirmation`, body);
  return createResponseHandling.parseResponse(res);
}

async function submitConfirmationCode(props) {
  const body = {
    confirmation_token: props.confirmationToken,
  }

  const res = await axios.post(`/users/confirmation/confirm`, body);
  return createResponseHandling.parseResponse(res);
}

export {
  signUp,
  resendConfirmationEmail,
  submitConfirmationCode,
};
